/** Valid values for statistics.category (must match DB enum statistic_category) */
export const STATISTIC_CATEGORIES = [
  'politics',
  'society',
  'economy',
  'culture',
  'entertainment',
  'sports',
  'technology',
  'science',
  'lifestyle',
  'energy',
  'unclassified',
] as const;

export type StatisticCategory = (typeof STATISTIC_CATEGORIES)[number];

const CATEGORY_ALIASES: Record<string, StatisticCategory> = {
  // English variants
  politic: 'politics',
  economic: 'economy',
  tech: 'technology',
  sport: 'sports',
  // Spanish (legacy / AI output)
  politica: 'politics',
  sociedad: 'society',
  economia: 'economy',
  cultura: 'culture',
  entretenimiento: 'entertainment',
  deportes: 'sports',
  tecnologia: 'technology',
  ciencia: 'science',
  inclasificables: 'unclassified',
  sin_categoria: 'unclassified',
  'sin-categoria': 'unclassified',
  // Thematic aliases
  energia: 'energy',
  energética: 'energy',
  environment: 'science',
  medioambiente: 'science',
  medio_ambiente: 'science',
};

/**
 * Normalizes a category string to a valid DB enum value.
 * Returns undefined if input is empty; falls back to 'unclassified' for unknown values.
 */
export function normalizeStatisticCategory(
  value: string | null | undefined
): StatisticCategory | undefined {
  if (value == null || String(value).trim() === '') {
    return undefined;
  }

  const key = String(value).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if ((STATISTIC_CATEGORIES as readonly string[]).includes(key)) {
    return key as StatisticCategory;
  }

  if (CATEGORY_ALIASES[key]) {
    return CATEGORY_ALIASES[key];
  }

  console.warn(`[CATEGORY] Unknown category "${value}" — using unclassified`);
  return 'unclassified';
}
